import { useQuery } from "@tanstack/react-query"
import { atom, useAtom } from 'jotai'
import { getInstitute } from "../api/institute"

const instituteIdDefault = atom(0)

export const useInstitute = () => {
  const [instituteId, setInstituteId] = useAtom(instituteIdDefault)

  const UpdateInstituteId = (id) => {
    setInstituteId(id)
  }

  return {
    instituteId,
    UpdateInstituteId
  }
}

export const useInstituteQuery = (instituteId) => {
  return useQuery({
    queryKey: ["institute", instituteId],
    queryFn: () => getInstitute(instituteId),
    isEnabled: !!instituteId && instituteId > 0, // Only run the query if instituteId is valid
  })
}

// export const useUpdateActiveInstituteMutation = (instituteId) => {
//   const queryClient = useQueryClient()
//   const { setInstituteId } = useInstitute();

//   return useMutation({
//     mutationFn: (instituteId) =>
//       setInstituteId(instituteId),
//     onSuccess: (data, variables) => {
//       return queryClient.invalidateQueries({queryKey: ["institute", variables]})
//     } 
//   })
// }